<template>
    <div>
        <div class="flex-page-content flex-container">
            <div class="flex-body body-scroll">
                <div class="container-fluid">

                    <div class="container-centered-s py-4">

                        <h5>{{ onboardingApplication.company.name }}</h5>
                        <form @submit.prevent="onSubmit">
                            <form-errors :errors="formErrors"/>

                            <div v-show="mode == 'survey' && currentQuestion">
                                <survey v-show="currentQuestion == 'q1'" :yaml="surveys.q1" :knowndata="knownData" :hidesubmit="true" @error="onWOTCFormError" ref="q1" />
                                <survey v-show="currentQuestion == 'q2'" :yaml="surveys.q2" :knowndata="knownData" :hidesubmit="true" @error="onWOTCFormError" ref="q2" />
                                <survey v-show="currentQuestion == 'q3'" :yaml="surveys.q3" :knowndata="knownData" :hidesubmit="true" @error="onWOTCFormError" ref="q3" />
                                <survey v-show="currentQuestion == 'q4'" :yaml="surveys.q4" :knowndata="knownData" :hidesubmit="true" @error="onWOTCFormError" ref="q4" />
                                <survey v-show="currentQuestion == 'q5'" :yaml="surveys.q5" :knowndata="knownData" :hidesubmit="true" @error="onWOTCFormError" ref="q5" />
                                <survey v-show="currentQuestion == 'q6'" :yaml="surveys.q6" :knowndata="knownData" :hidesubmit="true" @error="onWOTCFormError" ref="q6" />
                                <survey v-show="currentQuestion == 'q7'" :yaml="surveys.q7" :knowndata="knownData" :hidesubmit="true" @error="onWOTCFormError" ref="q7" />

                                <div class="row mb-2 d-flex align-items-center">
                                    <div class="col">
                                        <a href @click.prevent="previousQuestion">Back</a>
                                    </div>

                                    <div class="col text-right">
                                        <button class="btn btn-primary">Continue</button>
                                    </div>
                                </div>
                            </div>

                            <div v-show="mode == 'signature'">
                                <h3>WOTC Benefits Questionnaire</h3>
                                <hr/>

                                <p>
                                    Under penalties of perjury, I declare that I gave the above information to the employer on or before the day I was offered a job, and it is, to the best of my knowledge, true, correct, and complete.
                                </p>

                                <div class="row mb-2 d-flex align-items-center">
                                    <div class="col">
                                        <a href @click.prevent="mode = 'survey'; previousQuestion()">Back</a>
                                    </div>

                                    <div class="col text-right">
                                        <button class="btn btn-primary" @click.prevent="mode = 'complete'">Sign</button>
                                    </div>
                                </div>
                            </div>

                            <div v-show="mode == 'complete'">
                                <h3>WOTC Benefits Questionnaire</h3>
                                <hr/>

                                <div class="text-center pt-2 pb-4">

                                    <p><i class="fas fa-check text-primary"></i>&nbsp; Questionnaire complete &mdash; thank you for your responses.</p>

                                    <p>Next, we'll set up your HR information.</p>

                                </div>

                                <div class="row mb-2 d-flex align-items-center">
                                    <div class="col">
                                        <a href @click.prevent="previousQuestion">Back</a>
                                    </div>

                                    <div class="col text-right">
                                        <button class="btn btn-primary" @click.prevent="onSubmit">Continue</button>
                                    </div>
                                </div>
                            </div>

                        </form>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
import FormInput from '@/components/FormInput'
import FormErrors from '@/components/FormErrors'
import FormMixin from '@/mixins/Form'
import Survey from '@/components/PDFForm/Survey'
import WizardMixin from './WizardMixin'
import moment from 'moment'

const SURVEYS = {
    q1: `
title: WOTC Benefits Questionnaire
questions:
    - type: select-one
      slug: wotc_q1_food_stamps
      text: "Have you or a family member received food stamps within the last year?"
      options:

        - text: "No"
          slug: no

        - text: "Yes"
          slug: yes
          questions:

            - type: text
              slug: wotc_q1a_primary_recipient_name
              text: "If yes, please provide the name of the primary recipient"
        `,
    q2: `
title: WOTC Benefits Questionnaire
questions:
    - type: select-one
      slug: wotc_q2_veteran
      text: "Are you a veteran of the U.S. Armed Forces?"
      options:

        - text: "No"
          slug: no

        - text: "Yes"
          slug: yes
          questions:

            - type: select-one
              slug: wotc_q2a_unemployed_4_weeks
              text: "Were you unemployed for at least 4 weeks but less than 6 months in the last year?"
              options:

                - text: "No"
                  slug: no

                - text: "Yes"
                  slug: yes

            - type: select-one
              slug: wotc_q2b_unemployed_6_months
              text: "Were you unemployed for periods of time totaling at least 6 months last year?"
              options:

                - text: "No"
                  slug: no

                - text: "Yes"
                  slug: yes

            - type: select-one
              slug: wotc_q2c_disability
              text: "Were you entitled to compensation for a service-related disability and released from active duty in the last year?"
              options:

                - text: "No"
                  slug: no

                - text: "Yes"
                  slug: yes
        `,
    q3: `
title: WOTC Benefits Questionnaire
questions:
    - type: select-one
      slug: wotc_q3_tanf
      text: "Have you or a family member received cash assistance payments such as TANF (Temporary Assistance for Needy Families) within the last year?"
      options:

        - text: "No"
          slug: no

        - text: "Yes"
          slug: yes
          questions:

            - type: text
              slug: wotc_q3a_primary_recipient_name
              text: "If yes, please provide the name of the primary recipient"
        `,
    q4: `
title: WOTC Benefits Questionnaire
questions:
    - type: select-one
      slug: wotc_q4_exfelon
      text: "Are you an ex-felon?"
      options:
        - text: "No"
          slug: no

        - text: "Yes"
          slug: yes
          questions:

            - type: select-one
              slug: wotc_q4a_federal_or_state
              text: "What type of conviction was it?"
              options:
                - slug: fed
                  text: "Federal"

                - slug: state
                  text: "State"

            - type: text
              slug: wotc_q4b_conviction_state
              text: "State Convicted in"

            - type: date
              slug: wotc_q4c_conviction_date
              text: "Conviction Date"

            - type: date
              slug: wotc_q4d_release_date
              text: "Release Date"
    `,
    q5: `
title: WOTC Benefits Questionnaire
questions:
    - type: select-one
      slug: wotc_q5_ssi
      text: "Were you, or are you receiving Non-Retirement Based Supplemental Security Income (SSI)?"
      options:

        - text: "No"
          slug: no

        - text: "Yes"
          slug: yes
    `,
    q6: `
title: WOTC Benefits Questionnaire
questions:
    - type: select-one
      slug: wotc_q6_unemployment
      text: "Before today, have you been unemployed for the last six months, and received ANY unemployment benefits?"
      options:

        - text: "No"
          slug: no

        - text: "Yes"
          slug: yes
    `,
    q7: `
title: WOTC Benefits Questionnaire
questions:
    - type: select-one
      slug: wotc_q7_vocational_rehab
      text: "Are you a vocational rehab referral?"
      options:

        - text: "No"
          slug: no

        - text: "Yes"
          slug: yes
          questions:
            - type: select-one
              slug: wotc_q7a_vocational_rehab_referral
              text: "Which of the following referred you:"
              options:
                - text: "Rehabilitation agency approved by the state"
                  slug: agency

                - text: "Employment Network under the ticket to work program"
                  slug: employment_network

                - text: "Department of Veterans Affairs"
                  slug: veterans_affairs
        `,
}

export default {
    mixins: [FormMixin, WizardMixin],
    components: {
        FormInput,
        FormErrors,
        Survey,
    },
    props: ['onboardingApplication'],
    computed: {
        currentYAML() {
            return SURVEYS[this.currentQuestion]
        },
        surveys() {
            return SURVEYS
        },
        knownData() {
            // no known data for WOTC for now - will be filled in w/Python later before submitting to API
            const app = this.onboardingApplication
            return {
                'system': {
                },
                'employee': {
                },
                'employer': {
                },
            }
        },
    },
    data() {
        return {
            mode: 'survey',  // Can be 'survey', 'signature', or 'complete'
            formRules: {
            },
            formData: {
                action: 'answer-wotc',
            },
            currentQuestion: 'q1',
            completedQuestions: [],
        }
    },
    methods: {
        onWOTCFormError(error) {
            this.$bus.showError(error)
        },
        makeWOTCData() {
            const data = {}
            Object.assign(data, this.knownData)
            this.completedQuestions.forEach(q => {
                try {
                    Object.assign(data, this.$refs[q].getFormValues())
                } catch (ex) {
                    this.onWOTCFormError(ex)
                    return
                }
            })

            return data
        },
        onSubmit() {
            if (this.currentQuestion) {
                this.completedQuestions.push(this.currentQuestion)
            }

            const data = {
                action: 'answer-wotc',
                date: moment().format('MM/DD/YYYY'),
                datetime: moment().utc().format('YYYY-MM-DD HH:mm:ss') + ' Z',
            }
            Object.assign(data, this.makeWOTCData())
            this.formData = data

            if (this.currentQuestion) {
                this.nextQuestion()
            }
            else {
                this.$store.dispatch('START_LOADING')
                const wotcFormId = this.onboardingApplication.wotc_form.id ? this.onboardingApplication.wotc_form.id : this.onboardingApplication.wotc_form
                this.$api.post(`/me/onboarding/${this.onboardingApplication.id}/onboarding-application/wotc/save/${wotcFormId}`, data).then((resp) => {
                    this.$emit('updated', resp)
                    this.$emit('next')
                    this.$store.dispatch('STOP_LOADING')
                }).catch((errors) => {
                    this.errors = errors
                    this.formErrors = errors.__all__
                    this.onError()
                    this.$store.dispatch('STOP_LOADING')
                })
            }
        },
        reset: function() {
            this.errors = {}
            this.formErrors = []
        },
        nextQuestion() {
            const routing = {
                q1: {
                    wotc_q1_food_stamps__no: 'q2',
                    wotc_q1_food_stamps__yes: 'q2',
                },
                q2: {
                    wotc_q2_veteran__no: 'q3',
                    wotc_q2_veteran__yes: 'q3',
                },
                q3: {
                    wotc_q3_tanf__no: 'q4',
                    wotc_q3_tanf__yes: 'q4',
                },
                q4: {
                    wotc_q4_exfelon__no: 'q5',
                    wotc_q4_exfelon__yes: 'q5',
                },
                q5: {
                    wotc_q5_ssi__no: 'q6',
                    wotc_q5_ssi__yes: 'q6',
                },
                q6: {
                    wotc_q6_unemployment__no: 'q7',
                    wotc_q6_unemployment__yes: 'q7',
                },
                q7: {
                    wotc_q7_vocational_rehab__no: null,
                    wotc_q7_vocational_rehab__yes: null,
                },
            }

            const path = routing[this.currentQuestion]
            Object.keys(path).forEach(slug => {
                if (this.formData[slug]) {
                    this.currentQuestion = path[slug]
                    return false
                }
            })
            if (!this.currentQuestion && this.mode == 'survey') {
                if (this.makeWOTCData()['wotc_q1_is_worked_before__no']) {
                    this.mode = 'signature'
                } else {
                    this.mode = 'complete'
                }
            }
        },
        previousQuestion() {
            if (this.mode == 'complete') {
                this.mode = 'survey'
            }

            if (this.completedQuestions.length) {
                this.currentQuestion = this.completedQuestions.pop()
            }
            else {
                this.$router.push(this.previousPage)
            }
        },
    },
}


</script>
